module.exports = __webpack_public_path__ + "img/4d64b5b.png";